import AuthConfig from "../../public/authConfig.json";

export default {
  lk:AuthConfig.lk,
  lkmobile:AuthConfig.lkmobile,
  headPicBase:AuthConfig.headPicBase
};
